import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface Deal {
  property_description?: string;
  zillow_link?: string;
}

interface PropertyTabProps {
  formData: Deal;
  onChange: (field: keyof Deal, value: any) => void;
}

export function PropertyTab({ formData, onChange }: PropertyTabProps) {
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="property_description">Property Description</Label>
        <Textarea
          id="property_description"
          value={formData.property_description || ''}
          onChange={(e) => onChange('property_description', e.target.value)}
          rows={4}
          placeholder="Describe the property..."
        />
      </div>

      <div>
        <Label htmlFor="zillow_link">Zillow Link</Label>
        <Input
          id="zillow_link"
          value={formData.zillow_link || ''}
          onChange={(e) => onChange('zillow_link', e.target.value)}
          placeholder="https://zillow.com/..."
        />
      </div>
    </div>
  );
}
